import React, { useCallback, useEffect, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useToggle } from 'Hooks/useToggle'
import { Accordion } from 'Components/shared/accordion'
import { SidebarFieldWrapper } from 'Components/shared/sidebar'
import {
  setTimeBasedAddressVerified,
  selectAddressVerified,
} from './AddressVerifiedSlice'
import {
  setTimeBasedNameCleanliness,
  selectNameCleanliness,
} from './NameCleanlinessSlice'
import {
  setTimeBasedEmailCleanliness,
  selectEmailCleanliness,
} from './EmailCleanlinessSlice'
import { FilterSingleSelectDropdown } from 'Components/shared/singleselectdropdown'
import { Contract } from 'Services/contracts/contractsUtils'

interface VerificationProps {
  chosenItem: Partial<Contract>
  filterData?: any
}

export const Verification = memo(
  ({ chosenItem, filterData }: VerificationProps) => {
    const [expand, setExpand] = useToggle(false)
    const dispatch = useDispatch()

    const addressVerified = useSelector(selectAddressVerified)
    const nameCleanliness = useSelector(selectNameCleanliness)
    const emailCleanliness = useSelector(selectEmailCleanliness)

    /** This useEffect is for setting filters in edit segment */
    useEffect(() => {
      if (filterData?.[addressVerified.label])
        dispatch(setTimeBasedAddressVerified(filterData[addressVerified.label]))
      if (filterData?.[nameCleanliness.label])
        dispatch(setTimeBasedNameCleanliness(filterData[nameCleanliness.label]))
      if (filterData?.[emailCleanliness.label])
        dispatch(
          setTimeBasedEmailCleanliness(filterData[emailCleanliness.label])
        )
    }, [filterData])

    const dispatchAddressVerified = useCallback((value: string) => {
      dispatch(setTimeBasedAddressVerified(value))
    }, [])

    const dispatchNameCleanliness = useCallback((value: string) => {
      dispatch(setTimeBasedNameCleanliness(value))
    }, [])

    const dispatchEmailCleanliness = useCallback((value: string) => {
      dispatch(setTimeBasedEmailCleanliness(value))
    }, [])

    return (
      <Accordion
        setExpand={setExpand}
        expand={expand}
        title='VERIFICATION'
        disabled={chosenItem?.id ? false : true}
      >
        <SidebarFieldWrapper>
          <FilterSingleSelectDropdown
            label='Address Verified'
            values={addressVerified.values}
            value={addressVerified.selectedValue}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              dispatchAddressVerified(e.target.value)
            }}
          />

          <FilterSingleSelectDropdown
            label='Name Cleanliness Required'
            values={nameCleanliness.values}
            value={nameCleanliness.selectedValue}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              dispatchNameCleanliness(e.target.value)
            }}
          />
          <FilterSingleSelectDropdown
            label='Email Cleanliness Required'
            values={emailCleanliness.values}
            value={emailCleanliness.selectedValue}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              dispatchEmailCleanliness(e.target.value)
            }}
          />
        </SidebarFieldWrapper>
      </Accordion>
    )
  }
)
